@use '@lib/assets/styles/main.scss' as *;

.footer {
  position: sticky;
  bottom: 0;
  z-index: 1;
}

.footer td {
  //background-color: otherOne100;
  padding: 10px 16px;
  white-space: nowrap;
}

.footer::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  //border-top: 1px solid otherOne300;
}
